import React from 'react';
import { Select as SelectInput } from 'antd';
import { FieldLabel, FieldHint } from './field';

/** Labeled antd Select (36px). Optional `error` (message) marks it invalid; `hint` adds helper text. */
export const Select = function _Select({
    label = '',
    onChange,
    children,
    required,
    value,
    options,
    defaultValue,
    showSearch,
    filterOption,
    className = '',
    style = {},
    placeholder,
    allowClear,
    loading,
    disabled,
    mode,
    dropdownStyle = {},
    error,
    hint
}) {
    return (
        <div className={`min-w-[120px] ${className}`}>
            <FieldLabel label={label} required={required} />
            <SelectInput
                style={{
                    width: '100%',
                    ...style
                }}
                showSearch={showSearch}
                options={options}
                value={value}
                defaultValue={defaultValue}
                onChange={onChange}
                filterOption={filterOption}
                placeholder={placeholder}
                allowClear={allowClear}
                loading={loading}
                disabled={disabled}
                mode={mode}
                status={error ? 'error' : undefined}
                size="middle"
                popupMatchSelectWidth={false}
                dropdownStyle={{ minWidth: 220, ...dropdownStyle }}>
                {children}
            </SelectInput>
            <FieldHint error={error} hint={hint} />
        </div>
    );
};
